import React from 'react';
import { Box, Typography } from '@mui/material';
import { CatalogKeywordsTab } from '../wizard/CatalogKeywordsTab';

interface StepProps {
  catalogItemId?: string;
  ownerId?: string | null;
}

const NOTE =
  'Inventory & Albums helps you organize this object — give it an inventory number and assign it to one or more albums (collections). Keywords now live in Artwork Details.';

/**
 * Renders the Inventory & Albums step (inventory number and album/collection
 * memberships). Keywords were moved to the Artwork Details step; this step
 * still mounts the underlying CatalogKeywordsTab with `hideKeywords` so the
 * shared autosave/load logic stays intact.
 */
export const CatalogKeywordsStep: React.FC<StepProps> = ({ catalogItemId, ownerId }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    <Typography
      variant="body2"
      color="text.secondary"
      data-testid="catalog-keywords-step-note"
    >
      {NOTE}
    </Typography>
    <CatalogKeywordsTab
      catalogItemId={catalogItemId}
      ownerId={ownerId}
      hideAdditionalNotes
      hideKeywords
    />
  </Box>
);
